<script>
import { colorPrimaryMid, colorPrimaryTelenor } from "@/assets/tokens/js/es6";
import SupportsDarkMode from "~/mixins/platform/SupportsDarkMode.js";
import { mapGetters } from "vuex";

export default defineNuxtComponent({
	name: "ListBulletBullet",
	mixins: [SupportsDarkMode],

	computed: {
		...mapGetters(["isMobile"]),
		colorPrimaryTelenor() {
			return colorPrimaryTelenor;
		},
		iconSize() {
			if (this.isMobile) return "m";
			return "l";
		},
	},

	props: {
		icon: {
			type: String,
			default: "bullet",
		},
		image: {
			type: Object,
		},
		color: {
			type: String,
			default: colorPrimaryMid,
		},
	},
});
</script>

<template>
	<div
		class="list-bullets-bullet"
		:class="{ dark }"
	>
		<div class="icon-column">
			<img
				v-if="image"
				:src="image.src"
				:alt="image.alt"
			/>
			<TnIcon
				:name="icon"
				:color="dark ? colorPrimaryTelenor : color"
				:size="iconSize"
				v-else
			></TnIcon>
		</div>
		<div class="text-column">
			<h3>
				<slot name="heading"></slot>
			</h3>
			<div class="content">
				<slot></slot>
			</div>
		</div>
	</div>
</template>

<style scoped lang="scss">
.list-bullets-bullet {
	display: flex;
	flex-direction: row;

	.icon-column {
		width: 32px;
		margin-right: $spacing-s;

		@include breakpoint(mobile) {
			width: 24px;
		}
	}

	h3 {
		@include font-text-bold-l;
	}

	.content {
		overflow-wrap: anywhere;
		color: $color-neutrals-600-shade;

		@include font-text-l;
	}

	&.dark {
		.content {
			color: $color-neutrals-200-tint;
		}

		h3 {
			color: $color-neutrals-white;
		}
	}
}
</style>
